export function getEarlyNotificationTime(): Date {
    //Earlier section is 12 hours ago
    let earlierTime = new Date();
    earlierTime.setHours(earlierTime.getHours() - 12);
    return earlierTime;
}

export function isNullOrUndefined(obj: any) {
    return (obj === null || obj === undefined);
}